export const CONTRACTED_VS_PLAN_LE = '/contracted-plan-le-details';
